// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/footer.css'
import './assets/css/reset.css'
import store from './store'
import 'swiper/dist/css/swiper.css'
import 'animate.css';

Vue.config.productionTip = false

// import wx from "weixin-js-sdk";


// import preview from 'vue-photo-preview'
// import 'vue-photo-preview/dist/skin.css'

// let options = {
//   fullscreenEl: false,
// }
// Vue.use(preview, options)
// import preview from 'vue-photo-preview'
// import 'vue-photo-preview/dist/skin.css'
// Vue.use(preview)
// import Vue from 'vue'
import VueZoomer from 'vue-zoomer'
Vue.use(VueZoomer)


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store, // 把store对象添加到vue实例上
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js